import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m11.025 3.958 4.584 4.584m-4.584-4.584H6.86c-.92 0-1.667.747-1.667 1.667v8.75c0 .92.746 1.667 1.667 1.667h7.083c.92 0 1.667-.747 1.667-1.667V8.542l-4.584-4.584Zm0 0v2.917c0 .92.746 1.667 1.667 1.667h2.917l-4.584-4.584Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);